import { AnswerColumn, HeadlineViz } from '/@services/generated/graphql-types';

export const getHeadlineColumns = (
    headlineModel: HeadlineViz,
): AnswerColumn[] => [headlineModel.headlineColumn];
